import { t } from "@web-monorepo/i18n/macro";
import { getImageSrc } from "@web-monorepo/static-assets";
import type { ToolkitActivityVariant } from "components/BeyondToolkit/activityVariant";

// `variant` is the single source of truth for an activity's brand color.
// Both the activity chrome (`ToolkitAppScroller` / `FullBleedScreen`) and the
// `/beyondToolkit` landing-page tile (`ToolkitListItem`) map the variant to
// the same `--activity-bg` / `--activity-bg-image` CSS classes in their
// respective modules.

export const TABLE_TOPICS = () => ({
  description: t`Conversation starters to bring your family closer`,
  pageUrl: "/beyondToolkit/tableTopics",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/107.png",
  imgSrc: getImageSrc("toolkit/public/static/images/toolkit_table_topics.png"),
  loggingId: "table_topics",
  unlocked: true,
  title: t`Dinner topics`,
  variant: "dinnerTopics" satisfies ToolkitActivityVariant,
});

export const TIMER = () => ({
  description: t`Help your kids get ready on time or read longer with this countdown timer`,
  pageUrl: "/beyondToolkit/timer",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/42.png",
  imgSrc: getImageSrc("toolkit/public/static/images/toolkit_timer.png"),
  loggingId: "timer",
  title: t`Timer`,
  variant: "timer" satisfies ToolkitActivityVariant,
  unlocked: true,
});

export const MINDFULNESS = () => ({
  description: t`Relaxing meditations to put your child's mind at ease`,
  pageUrl: "/beyondToolkit/mindfulness",
  imgSrc: getImageSrc("toolkit/public/static/images/toolkit_mindfulness.png"),
  loggingId: "mindfulness",
  unlocked: true,
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/55.png",
  title: t`Bedtime meditations`,
  variant: "bedtimeMeditations" satisfies ToolkitActivityVariant,
});

export const BEDTIME_STORIES = () => ({
  title: t`Bedtime stories`,
  description: t`Short stories for you and your child to listen to before bed`,
  pageUrl: "/beyondToolkit/bedtimeStories",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/53.png",
  imgSrc: getImageSrc("toolkit/public/static/images/toolkit_bedtime.png"),
  loggingId: "bedtime",
  unlocked: true,
  variant: "bedtimeStories" satisfies ToolkitActivityVariant,
});

export const READ_ALONGS = () => ({
  title: t`Read alongs`,
  description: t`Educational storybooks that increase kids’ love for reading`,
  pageUrl: "/beyondToolkit/readAlongs",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/94.png",
  imgSrc: "https://dojoicons.classdojo.com/beyond_school/300/94.png",
  loggingId: "read_alongs",
  unlocked: true,
  variant: "readAlongs" satisfies ToolkitActivityVariant,
});

export const MUSIC = () => ({
  description: t`Dreamy tunes to help your child fall asleep faster`,
  pageUrl: "/beyondToolkit/music",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/86.png",
  imgSrc: getImageSrc("toolkit/public/static/images/toolkit_music.png"),
  loggingId: "music",
  unlocked: true,
  title: t`Sleep music`,
  variant: "sleepMusic" satisfies ToolkitActivityVariant,
});

export const WHOSE_TURN = () => ({
  description: t`The fun way to remember whose turn it is or to choose who's next`,
  pageUrl: "/beyondToolkit/whoseTurn",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/137.png",
  loggingId: "whose_turn",
  unlocked: true,
  title: t`Whose turn`,
  variant: "whoseTurn" satisfies ToolkitActivityVariant,
  imgSrc: getImageSrc("toolkit/public/static/images/toolkit_whose_turn.png"),
});

export const BRUSH_TEETH = () => ({
  description: t`Two minutes of brushing music`,
  pageUrl: "/beyondToolkit/brushTeeth",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/88.png",
  loggingId: "brush_teeth",
  unlocked: true,
  title: t`Brush your teeth!`,
  variant: "brushTeeth" satisfies ToolkitActivityVariant,
  duration: 119,
  mainAudio: "/static/media/activity-brushteeth_song.mp3",
});

export const SHAKE_SILLIES = () => ({
  description: t`Dance it all away before bed`,
  pageUrl: "/beyondToolkit/shakeSillies",
  imgUrl: "https://dojoicons.classdojo.com/beyond_school/300/119.png",
  loggingId: "shake_sillies",
  unlocked: true,
  title: t`Get the wiggles out!`,
  variant: "shakeSillies" satisfies ToolkitActivityVariant,
  duration: 177,
  mainAudio: "/static/media/activity-wiggleit_song.mp3",
});
